import { useElementsEditForm, UseElementsEditFormFormArgs } from '../../../hooks';
import { FirmMemberFormValues } from '../types';

export const useEditFirmMemberForm = (args: UseElementsEditFormFormArgs<FirmMemberFormValues>) =>
  useElementsEditForm<FirmMemberFormValues>(args);
